export default () => {

  const s = {};
  const prefix = 'ev';
  const init = () => {
    s.root = document.getElementById('event-select');
    if (!s.root) {
      // eventトップページの場合、詳細ページをfetchにてダウンロードしてくる為
      // ダウンロード後に再度実行させる：/assets/scripts/data/event_top.js
      document.body.buildSelectAccordion = init;
      return;
    }
    console.log('init sort accordion')

    collectPageData();
    buildSelectAccordion();
  }

  const collectPageData = () => {
    s.isEventTop = (() => {
      const detailPageRegExp = new RegExp(/^\/event\/?(detail\/|[\d]*.html)/);
      return !detailPageRegExp.test(location.pathname);
    })();
  }
  const buildSelectAccordion = () => {
    const accordion = s.root.querySelector('.js-accordion');
    const accordionBody = accordion.querySelector(`.${prefix}-sort__select`);

    const filteringSelectItems = filterdSelectItem(accordionBody);
    setSelectItemCurrent(filteringSelectItems);

    bindClickAccordionAction(accordion, accordionBody);
  }

  // 必要なリンクのみを残す
  // ・共通処理
  //   1, 現在のmsを取得する
  // ・eventトップページの場合
  //   2-1, 開催最終日が現在日時よりも前のものを削除
  // ・詳細ページの場合
  //   2-2, 現在表示されているページではない物 かつ 開催最終日が現在日時よりも前のものを削除
  const filterdSelectItem = (selectBody) => {
    const selectItems = selectBody.querySelectorAll(`.${prefix}-sort__list-item`);
    const currentDatetime = Date.now();
    [].filter.call(selectItems, item => {
        const endDateObj = new Date(convertHyphenFormatDateStr(item.dataset.end));
        endDateObj.setHours(23, 59, 59);
        if (s.isEventTop) {
          // ・eventトップページの場合
          return endDateObj.getTime() < currentDatetime;
        } else {
          // ・詳細ページの場合
          const pageNameRegExp = new RegExp(`${item.dataset.page}.html`);
          return !pageNameRegExp.test(location.pathname) && endDateObj.getTime() < currentDatetime
        }
      })
      .forEach(item => item.remove());

    return selectBody.querySelectorAll(`.${prefix}-sort__list-item`);
  }
  // Currentを付与する
  // ・eventトップページの場合
  //   フィルタリングされたアイテムの先頭を取り出す
  // ・詳細ページの場合
  //   data属性と合致するものを取り出す
  const setSelectItemCurrent = (selectItems) => {
    const currentItem = (() => {
      if (s.isEventTop) {
        // ・eventトップページの場合
        return selectItems[0]
      }
      // ・詳細ページの場合
      const pageNameResult = /\/(\d+)\.html/.exec(location.pathname);
      return pageNameResult
        && pageNameResult[1]
        && (() => {
          const filterdItems = [].filter.call(selectItems, item => pageNameResult[1] == item.dataset.page);
          return filterdItems.length > 0
            && filterdItems[0]
        })()
    })();
    currentItem
      && currentItem.classList.add('is-current');
  }
  const bindClickAccordionAction = (accordion, body) => {
    const accordionTarget = accordion.querySelector(`.${prefix}-sort__target`);

    accordionTarget.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = accordion.classList.contains('is-open');
      if (isOpen) {
        accordionBodyCloseAction(body);
      } else {
        accordionBodyOpenAction(body);
      }
      accordion.classList.toggle('is-open');
      accordionTarget.classList.toggle('is-selected');
    });
  }
  const accordionBodyOpenAction = (body) => {
    const entity = body.firstElementChild;
    const entityHeight = entity.offsetHeight;
    body.style.height = `${entityHeight}px`;
  }
  const accordionBodyCloseAction = (body) => {
    body.style.height = '0px';
  }

  init ();

  return {}
}


const convertHyphenFormatDateStr = (dateStr) => {
  return `${dateStr.slice(0, 4)}-${dateStr.slice(4, 6)}-${dateStr.slice(6)}`;
}
